module.exports = __webpack_public_path__ + "img/3.1c5d8906.png";